import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import UsdgBolsContainer from '../../containers/billing/UsdgBols';
import AuthUserContainer from '../../containers/AuthUser';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import { Typography } from '@material-ui/core';
// import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import BolLinkedStatus from '../../components/billing/BolLinkedStatus';
import invoiceIcon from '../../images/invoicePdf.svg';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const columns = [
	{
		sortId: 'usdgBolId',
		displayId: 'usdgBolId',
		label: 'ID',
	},
	{
		sortId: 'terminalDisplay',
		displayId: 'terminalDisplay',
		label: 'Terminal',
	},
	{
		sortId: 'bolNumber',
		displayId: 'bolNumber',
		label: 'BOL #',
	},
	{
		sortId: 'railcarDisplay',
		displayId: 'railcarDisplay',
		label: 'Railcar #s',
	},
	{
		sortId: 'loadingNumber',
		displayId: 'loadingNumber',
		label: 'Loading #',
	},
	{
		sortId: 'startDateTime',
		displayId: 'startDateTimeFormatted',
		label: 'Start',
	},
	{
		sortId: 'stopDateTime',
		displayId: 'stopDateTimeFormatted',
		label: 'Stop',
	},

	{
		sortId: 'netGallons',
		displayId: 'netGallons',
		label: 'Net Gallons',
	},
	{
		sortId: 'grossGallons',
		displayId: 'grossGallons',
		label: 'Gross Gallons',
	},
	{
		sortId: 'linkedStationDeliveryId',
		displayId: 'linkedStationDeliveryDisplay',
		label: 'Linked Delivery',
	},
	{
		sortId: 'linkedStatus',
		displayId: 'linkedStatusDisplay',
		label: 'Linked Status',
	},
];

class UsdgBols extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'usdgBolId',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isInvalidOpen: false,
		};
	}

	componentDidMount() {
		const { usdgBols, usdgBolSearch } = this.props;

		if (!usdgBols) {
			usdgBolSearch({ afterDateTime: moment().subtract(2, 'months').format('YYYY-MM-DD') });
		} else {
			this.formatUsdgBols();
		}
	}

	componentDidUpdate(prevProps) {
		const { usdgBols } = this.props;
		if (prevProps.usdgBols !== usdgBols) {
			this.formatUsdgBols();
		}
	}

	formatUsdgBols = () => {
		const { usdgBols, stationMap, terminalMap } = this.props;

		const rows = [];
		usdgBols.forEach((usdgBol) => {
			const {
				usdgBolId,
				//dateCreated,
				startDateTime,
				stopDateTime,
				terminalId,
				// bolNumber,
				railcarNumber1,
				railcarNumber2,
				// railcarNumbers,
				// loadingNumber,
				// customerId,
				// product,
				// netGallons,
				// grossGallons,
			} = usdgBol;

			usdgBol.key = usdgBolId;
			//			usdgBol.dateCreatedFormatted = moment(dateCreated).format('M/D/YY h:mm a');
			usdgBol.startDateTimeFormatted = moment(startDateTime).format('M/D/YY h:mm a');
			usdgBol.stopDateTimeFormatted = moment(stopDateTime).format('M/D/YY h:mm a');
			//const isOverTwoDays = moment().diff(moment(dateCreated), 'days') > 2;

			/*
			usdgBol.bolPdf = bolPdfResourceId ? (
				<>
					<Button
						onClick={() => {
							this.handlePdfClick(bolPdfResourceId);
						}}
					>
						View
					</Button>
				</>
			) : isOverTwoDays ? (
				<div style={{ color: 'red' }}>Missing!</div>
			) : (
				'Pending...'
			);
			*/
			const railcarNumbers = [railcarNumber1];
			if (railcarNumber2) {
				railcarNumbers.push(railcarNumber2);
			}

			usdgBol.railcarDisplay = _.isEmpty(railcarNumbers) ? '-' : railcarNumbers.join(', ');

			usdgBol.linkedStatusDisplay = (
				<BolLinkedStatus linkedStatus={usdgBol.linkedStatus} message={usdgBol.linkedErrorMessage} />
			);
			const terminal = terminalMap[terminalId] || { name: 'Missing' };
			usdgBol.terminalDisplay = terminal.name;

			if (usdgBol.linkedStationDeliveryId) {
				const station = stationMap[usdgBol.linkedStationId] || { number: 'Missing' };
				usdgBol.linkedStationDeliveryDisplay = (
					<div>
						<div style={{ whiteSpace: 'nowrap' }}>
							Station Delivery #
							<a
								href={`/logistics/stationDelivery/update/${usdgBol.linkedStationDeliveryId}`}
								style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
								target="_blank"
								rel="noreferrer noopener"
							>
								<strong>{usdgBol.linkedStationDeliveryId}</strong>
							</a>
						</div>
						<div>
							Station: {station.number} / Tank: {usdgBol.linkedTankNumber}
						</div>
					</div>
				);
			}

			rows.push(usdgBol);
		});
		this.setState({ rows });
	};

	handleView = (usdgBolId) => {
		this.props.history.push(`/billing/usdgBol/view/${usdgBolId}`);
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePdfClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	render() {
		const { classes, resourceMap } = this.props;
		const { rows, order, orderBy } = this.state;

		if (!rows) {
			return <div>Loading the IECFT BOLs...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>IECFT BOLs</span>
							</Typography>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<EnhancedTable
							columns={columns}
							rows={rows}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>

						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
	closeInvalidDialog = () => {
		this.setState({ isInvalidOpen: false });
	};
}

UsdgBols.propTypes = {
	classes: PropTypes.object.isRequired,
	usdgBolSearch: PropTypes.func.isRequired,
	usdgBols: PropTypes.array,

	showErrors: PropTypes.func.isRequired,
	resourceMap: PropTypes.object,
	stationMap: PropTypes.object,
	terminalMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	UsdgBolsContainer,
])(UsdgBols);
